import { CMSResource } from "app/resources/cmsresource";

export class HeaderBarLinkResource extends CMSResource {

	rid: number;	
	active: boolean;	
	configurable: boolean;	
	openUrlBlank: boolean;
	url: string;	
	titleRo: string;	
	titleFr: string;	
	titleEn: string;
	titleDe: string;
	descriptionRo: string;	
	descriptionFr: string;
	descriptionEn: string;
	descriptionDe: string;
    showEdit: boolean = false;

}